export interface PaginationRequestModel {
  page?: number;
  limit?: number;
  parameters?: { [key: string]: any };
  orderBy?: string;
  orderByKey?: string;
  direction?: DirectionEnum;
  isPagination?: boolean;
   backendName?: string
}

export enum DirectionEnum {
  asc = 'asc',
  desc = 'desc',
}






